export function state(initialState) {
  return {
    modalOpen: false,
    modalType: null,
    modalData: null
  };
}
